module.exports = __webpack_public_path__ + "static/img/top.26ebea68.png";